var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackHamburgerMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:menu-fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 18.4297C20.3852 18.4299 20.7556 18.5783 21.0344 18.8441C21.3132 19.1099 21.479 19.4728 21.4975 19.8576C21.516 20.2424 21.3858 20.6195 21.1338 20.9109C20.8818 21.2023 20.5274 21.3855 20.144 21.4227L20 21.4297H4C3.61478 21.4295 3.24441 21.2811 2.96561 21.0153C2.68682 20.7494 2.52099 20.3865 2.50248 20.0018C2.48396 19.617 2.61419 19.2399 2.86618 18.9485C3.11816 18.6571 3.47258 18.4739 3.856 18.4367L4 18.4297H20ZM20 11.4297C20.3978 11.4297 20.7794 11.5877 21.0607 11.869C21.342 12.1503 21.5 12.5319 21.5 12.9297C21.5 13.3275 21.342 13.709 21.0607 13.9903C20.7794 14.2717 20.3978 14.4297 20 14.4297H4C3.60218 14.4297 3.22064 14.2717 2.93934 13.9903C2.65804 13.709 2.5 13.3275 2.5 12.9297C2.5 12.5319 2.65804 12.1503 2.93934 11.869C3.22064 11.5877 3.60218 11.4297 4 11.4297H20ZM20 4.42969C20.3978 4.42969 20.7794 4.58772 21.0607 4.86903C21.342 5.15033 21.5 5.53186 21.5 5.92969C21.5 6.32751 21.342 6.70904 21.0607 6.99035C20.7794 7.27165 20.3978 7.42969 20 7.42969H4C3.60218 7.42969 3.22064 7.27165 2.93934 6.99035C2.65804 6.70904 2.5 6.32751 2.5 5.92969C2.5 5.53186 2.65804 5.15033 2.93934 4.86903C3.22064 4.58772 3.60218 4.42969 4 4.42969H20Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackHamburgerMenuIcon);
export default __webpack_public_path__ + "static/media/black_hamburger_menu_icon.f7251cb36c3a8b3ac2abc58867392700.svg";
export { ForwardRef as ReactComponent };